module.exports = {
	"books": {
		"-LKvJ53YsQMlBJnE_V7M": {
			"bookUrl": "https://firebasestorage.googleapis.com/v0/b/bookroom-bf3a0.appspot.com/o/bookTemplate.png?alt=media",
			"coverUrl": "https://firebasestorage.googleapis.com/v0/b/bookroom-bf3a0.appspot.com/o/coverTemplate.png?alt=media",
			"isbn": "NNN-N-NNNN-NNNNN",
			"sectionlabel": "LT Test Section",
			"sortorder": 0,
			"title": "Book Title",
			"type": 0,
			"sound": "https://firebasestorage.googleapis.com/v0/b/bookroom-dev.appspot.com/o/Example%20Sound.mp3?alt=media",
			"transcript": "Example Text"
		}
	},
	"sections": {
		"-LKvJ53YsQMlBJnE_V7M": {
			"name": "New section",
			"code": "Code",
			"order": 2147483647
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/schema.json
// module id = 816
// module chunks = 0